export default{
    init(){
        this.openCloseListeners();
        this.selectValue();
    },

    openCloseListeners(){
        $('body').on('click', 'c-select c-selected-value', (e)=>{
            const parent = $(e.currentTarget).parent();

            const list = parent.find('c-options-container');
            parent.hasClass('opened') ? parent.removeClass('opened') : parent.addClass('opened');
            let posX = 0;
            let posY = $(parent).height() + 5;
            if (document.documentElement.clientWidth < ($(parent).offset().left + $(list).width())) {
                posX = $(parent).width() - $(list).width();
            }

            if (document.documentElement.clientHeight < ($(parent).offset().top + $(parent).height() + 5 + $(list).height())) {
                posY = -$(list).height() - 5;
            }

            list.css({left: posX, top: posY});
        })
    },

    selectValue(){
        $('body').on('click', 'c-select c-option', (e)=>{
            console.log(e.target.tagName);
            if (e.target.tagName !== 'INPUT') {
                $(e.currentTarget).find('input').click();
                /* if ($(e.currentTarget).find('input').is(':checked')) {
                    $(e.currentTarget).find('input').prop('checked', false);
                } else {
                    $(e.currentTarget).find('input').prop('checked', true);
                } */
            }

            this.updateValueInSelect($(e.currentTarget).parents('c-select'))
        })
    },
    updateValueInSelect(select){
        const selectedValue = select.find('c-selected-value');
        const selectedOptions = select.find('c-option').toArray();
        selectedValue.text('');
        selectedOptions.forEach(element => {
            if ($(element).find('input').is(':checked')) {
                if (selectedValue.text() == '') {
                    if ($(element).find('c-option-main-text').length>0) {
                        selectedValue.text($(element).find('c-option-main-text').text() +' '+ ($(element).find('c-option-postfix-text').text()))
                    }else{
                        selectedValue.text($(element).text());
                    }
                } else {
                    if ($(element).find('c-option-main-text').length>0) {
                        selectedValue.text(selectedValue.text() + ', ' + $(element).find('c-option-main-text').text() +' '+ $(element).find('c-option-postfix-text').text());
                    } else {
                        selectedValue.text(selectedValue.text() + ', ' + $(element).text());
                    }
                }
            }
        });
    }
}
